import getPageLoadTimeDomReady from "./getPageLoadTimeDomReady";

export const loadingDataOnPageLoad = (state, { payload }) => {
  if (payload === false) {
    return {
      ...state,
      globals: {
        ...state.globals,
        pageLoadTimeDomReady: getPageLoadTimeDomReady()
      }
    };
  }

  return state;
};
